import { Checkbox, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Dispatch, SetStateAction, useCallback, useMemo } from 'react';

import { IcaoIataCode } from '../../../../../../../../backend';
import { StyledPaper } from './TransfertList.style';

export const AirlinesList = ({
    checked,
    items,
    search,
    setChecked,
    airlines,
}: {
    checked: number[];
    items: number[];
    search: string;
    setChecked: Dispatch<SetStateAction<number[]>>;
    airlines: IcaoIataCode[];
}) => {
    const filteredItems = useMemo(
        () =>
            items.filter(index => airlines[index]?.iata.startsWith(search) || airlines[index]?.icao.startsWith(search)),
        [airlines, items, search],
    );

    const handleToggle = useCallback(
        (value: number) => {
            setChecked(o => {
                const currentIndex = o.indexOf(value);
                const newChecked = [...o];

                if (currentIndex === -1) {
                    newChecked.push(value);
                } else {
                    newChecked.splice(currentIndex, 1);
                }
                return newChecked;
            });
        },
        [setChecked],
    );

    return (
        <StyledPaper>
            <List dense component="div" role="list">
                {filteredItems.map(value => {
                    const labelId = `transfer-list-item-${value}-label`;
                    return (
                        <ListItem key={value} role="listitem" onClick={() => handleToggle(value)}>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked.indexOf(value) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{
                                        'aria-labelledby': labelId,
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id={labelId}
                                sx={{ color: 'white' }}
                                primary={`${airlines[value].icao} / ${airlines[value].iata}`}
                            />
                        </ListItem>
                    );
                })}
                <ListItem />
            </List>
        </StyledPaper>
    );
};
